/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Learn_Image_AltInputs */

const en_home_learn_image_alt = /** @type {(inputs: Home_Learn_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two circles selected in CADCraft, showing blue grips and the Properties panel`)
};

/**
* | output |
* | --- |
* | "Two circles selected in CADCraft, showing blue grips and the Properties panel" |
*
* @param {Home_Learn_Image_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_learn_image_alt = /** @type {((inputs?: Home_Learn_Image_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Learn_Image_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_learn_image_alt(inputs)
});
export { home_learn_image_alt as "home.learn.image_alt" }